export const isProd = import.meta.env.PROD || false;
export const isTest = import.meta.env.MODE === 'test';
